<template>
	<footer class="footer">
		<div class="container">
			<div class="content has-text-centered">
				<p>
					&copy; DailyCare Pty Ltd &middot;
					<a
						href="https://www.dailycare.com.au/terms-of-use/"
						target="_blank"
						rel="noreferrer"
						>Terms of use</a
					>
					&middot;
					<a
						href="https://www.dailycare.com.au/privacy-policy/"
						target="_blank"
						rel="noreferrer"
						>Privacy policy</a
					>
					<deploy-date></deploy-date>
				</p>
			</div>
		</div>
	</footer>
</template>

<script>
import DeployDate from "@shared/components/DeployDate";

export default {
	components: { DeployDate }
};
</script>

<style scoped>
.footer {
	padding: 3rem 1.5rem;
	font-size: 0.9em;
	/* 
		method for pinning footer to bottom of page.
		will have to come back to this at some point
	*/
	/* flex-shrink: 0; */
}
</style>
